// -------------------------------------------------------
// Free Gift-------------------------------------------
// --

let freeGift = function () {

    // Base vars
    let freeGiftEnabled = false;
    let giftThreshold = '95';
    let messageContainer = $('.km-message-gwp');
    let progressBar = $('#km-progress-bar-line');
    let GWPcontainer = $('#GWP-container');
    let GWPcontainerMini = $('#GWP-container-mini');

    // Main functions
    const check = function(value) {

        // Update Progress Bar
        let width = Math.round(value / parseInt(giftThreshold) * 100) + '%';
        if(Math.round(value / parseInt(giftThreshold) * 100) > 100) {
            progressBar.width('100%');
            progressBar.addClass('complete');
        } else {
            progressBar.width(width);
            progressBar.removeClass('complete');
        }

        // Check to see only the current GWP is in the cart
        $.getJSON('/cart.js', function(cart) {

            // Cycle products in cart
            for(let i = 0; i < cart.items.length; i++ ) {
                if(cart.items[i].title.indexOf("FREE GIFT") !== -1 && selectedProductID !== cart.items[i].product_id) {
                    // Remove this GWP from cart, it shouldn't be here
                    jQuery.post('/cart/update.js', {
                        updates: {
                            [cart.items[i].variant_id]: 0
                        },
                        success: function () {
                            console.log("Removed invalid GWP");
                            return false;
                        }
                    });
                }
            }

            // Check if there's stock of the product
            if(selectedProductInventory) {

                let productRoute = 'products/' + selectedProductHandle + '.js';
                $.getJSON(window.Shopify.routes.root + productRoute, function(product) {


                    if(product.available) {

                        // Ensure GWP container is visible
                        if(GWPcontainer.is(":hidden")) {
                            GWPcontainer.fadeIn();
                        }


                        // Check current cart subtotal against threshold
                        if(value >= parseInt(giftThreshold)) {

                            // Update message
                            messageContainer.find(".is-false").hide();
                            messageContainer.find(".km-js-append-product-title").text(selectedProductTitle);
                            messageContainer.find(".is-true").show();

                            // Add gift to cart, if not already
                            addFreeGift();

                        } else {

                            // Calculate difference between threshold and cart value
                            let giftDifference = parseFloat(parseInt(giftThreshold) - value).toFixed(2);

                            // Update message
                            messageContainer.find(".is-true").hide();
                            messageContainer.find(".km-js-append-product-title").text(selectedProductTitle);
                            messageContainer.find('.km-diff').text("$" + giftDifference);
                            messageContainer.find(".is-false").show();


                            // Remove gift from cart, if not already
                            removeFreeGift();
                        }

                    } else {

                        // Remove gift from cart, if not already
                        removeFreeGift();

                        // Hide gift container
                        GWPcontainer.hide();

                    }

                });


            } else {

                // Ensure GWP container is visible
                if(GWPcontainer.is(":hidden")) {
                    GWPcontainer.fadeIn();
                }

                // Check current cart subtotal against threshold
                if(value >= parseInt(giftThreshold)) {

                    // Update message
                    messageContainer.find(".is-false").hide();
                    messageContainer.find(".km-js-append-product-title").text(selectedProductTitle);
                    messageContainer.find(".is-true").show();

                    // Add gift to cart, if not already
                    addFreeGift();

                } else {

                    // Calculate difference between threshold and cart value
                    let giftDifference = (parseInt(giftThreshold) - value);

                    // Update message
                    messageContainer.find(".is-true").hide();
                    messageContainer.find(".km-js-append-product-title").text(selectedProductTitle);
                    messageContainer.find('.km-diff').text("$" + giftDifference);
                    messageContainer.find(".is-false").show();


                    // Remove gift from cart, if not already
                    removeFreeGift();
                }

            } // End check if inventory tracking is enabled

            //console.log("checked");
            return false;
        });


    }

    const addFreeGift = function () {

        // Base vars
        let alreadyAdded = false;
        let GWPquantity = 0;

        // Check if already added
        $.getJSON('/cart.js', function(cart){



            // Cycle products in cart
            for(let i = 0; i < cart.items.length; i++ ) {
                if(selectedProductID === cart.items[i].product_id) {
                    alreadyAdded = true;
                    GWPquantity = cart.items[i].quantity;
                }
            }


            // Check quantity, and ensure it stays at a max of 1
            if(alreadyAdded === true && GWPquantity > 1) {

                jQuery.post('/cart/update.js', {
                    updates: {
                        [selectedProductVariantID]: 1
                    },
                    success: function () {
                        if ($('body').hasClass("template-cart")) {
                            setTimeout(function () {
                                location.reload();
                            }, 250);
                            return false;
                        } else {
                            $('drawer-close-button').trigger('click');
                        }
                    }
                });

            }

            // Go ahead and add free gift
            if(alreadyAdded === false) {

                /*jQuery.post('/cart/add.js', {
                    quantity: 1,
                    id: parseInt(selectedProductVariantID),
                    success: function () {

                        console.log(selectedProductVariantID);
                        if ($('body').hasClass("template-cart")) {
                            setTimeout(function () {
                                location.reload();
                            }, 250);
                        } else {
                            $('drawer-close-button').trigger('click');
                        }

                        return false;
                    }
                });*/

                this.miniCart = document.querySelector('mini-cart');
                let variantId = parseInt(selectedProductVariantID);

                if (variantId) {
                    if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
                        Shopify.postLink(theme.routes.cart_add_url, {
                            parameters: {
                                id: variantId,
                                quantity: 1
                            },
                        });
                        return;
                    }

                    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

                    const body = JSON.stringify({
                        id: variantId,
                        quantity: 1,
                        sections: sections,
                        sections_url: window.location.pathname
                    });

                    fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
                        .then((response) => response.json())
                        .then((parsedState) => {
                            if (parsedState.status === 422) {
                                document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                                    detail: {
                                        errorMessage: parsedState.description
                                    }
                                }));
                            }
                            else {
                                this.miniCart && this.miniCart.renderContents(parsedState);

                                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                                    detail: {
                                        product: parsedState
                                    }
                                }));
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                        .finally(() => {

                        });
                }


            }

        });

    }

    // Remove gift
    const removeFreeGift = function() {

        // Base vars
        let alreadyAdded = false;

        // Check if already added
        $.getJSON('/cart.js', function(cart){

            // Cycle products in cart
            for(let i = 0; i < cart.items.length; i++ ) {
                if(selectedProductID === cart.items[i].product_id) {
                    alreadyAdded = true;
                }
            }

            // Go ahead and remove free gift
            if(alreadyAdded === true) {

                //console.log("removing");

                jQuery.post('/cart/update.js', {
                    updates: {
                        [selectedProductVariantID]: 0
                    },
                    success: function () {

                        setTimeout(function () {
                            location.reload();
                        }, 250);
                        return false;

                    }
                });

            }

        });

    }

    // Init the free gift function on cart page, if enabled
    if(freeGiftEnabled) {

        // Obtain cart value
        $.getJSON('/cart.js', function(cartData) {
            let cartSubtotal = (cartData.items_subtotal_price / 100);
            check(cartSubtotal);
            return false;
        });

        // Listen for cart update event, and re-calculate applicability for free gift item
        document.addEventListener('cart:updated', function (e) {

            //console.log(e.detail);
            setTimeout(function() {
                $.getJSON('/cart.js', function(cart){

                    // Base vars
                    const currentTotal = (cart.items_subtotal_price / 100);

                    // Check if threshold reached for free item
                    check(currentTotal);

                    return false;

                });
            }, 200);
        }, false);


        /*document.addEventListener('cart:updated', function (e) {
            setTimeout(function() {
                $.getJSON('/cart.js', function(cart){

                    // Base vars
                    const currentTotal = (cart.items_subtotal_price / 100);

                    // Check if threshold reached for free item
                    check(currentTotal);

                })
            }, 200);
        }, false);*/


    }



}

// Call the freeGift function when cart page is visible
/*if ($('body').hasClass("template-cart")) {



}*/
// Free gift
let freeGiftEnabled = false;
if(freeGiftEnabled) {
    freeGift();
}